import { toast } from 'react-toastify';
import { Context } from '../companiesMachine';

const showError = (ctx: Context, evt) => {
    toast(evt.data.message);
};

export default showError;
